module.exports = __webpack_public_path__ + "img/optional.75f8e0c9.png";